import React from "react";
import { startPasswordReset } from "../helpers/ad";

const ResetPassword = () => (
  <div>
    <h4 className="tw-text-xl tw-py-4 tw-font-bold">Reset Account Password</h4>
    <p>
      To reset your account password please click on the button below to begin
      the process.
    </p>
    <p>
      <button
        className="btn btn-primary tw-mt-4 tw-mb-12"
        onClick={startPasswordReset}
      >
        Reset Account Password
      </button>
    </p>
  </div>
);

export default ResetPassword;
